// src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "./theme/ThemeProvider";
import { AuthProvider } from "./auth/AuthProvider"; 


import { initGA } from "./lib/analytics";

initGA();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>       {/* <-- wrap here */}
        <App />
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
